const testimonials = [
    {
        "id": 1,
        "name": "Kim",
        "content": "I wouldn't trust anyone else with my skin. Her knowledge, skill, and attention to detail are unmatched. I have complete confidence in whatever she recommends. Peels, myolift, you name it. And the results are always amazing. I constantly get compliments on my skin and everyone thinks I'm younger than I am. I'm grateful to have found her and couldn't recommend her more highly.",
        "skinIssues": "Sagging skin and fine lines",
        "clientSince": "2010" 
    },
    {
        "id": 2,
        "name": "Debra D",
        "content": "Jannine is by far the best esthetician. She is thorough and extremely knowledgeable in all aspects of skin care. I highly recommend Jannine",
        "clientSince": "2010" 
    },
    {
        "id": 3,
        "name": "Mary V",
        "content": "My family and friends say my skin looks 20 years younger than I am, all because I am conistent at keeping up with Jannine and her recommendations.",
        "clientSince": "2006" 
    },
    {
        "id": 4,
        "name": "Lori",
        "content": "I won't let anyone else ever touch my skin! My skin looks amazing for 20 years plus! When you have the best, why settle for less?",
        "clientSince": "2006" 
    },
    {
        "id": 5,
        "name": "Carly",
        "content": "In combination with Mylift to strengthen my forhead lines, specialixed treatments for targetting my brown spots, and skin peels for overall texture & dryness, my forehead lines are way less noticeable, my brown spots are mostly gone, and my overall skin texture is much better. My experience and results have been amazing! I highly recommend Jannine for everyone's skin improvement esthetician!",
        "clientSince": "2025" 
    },
    {
        "id": 6,
        "name": "Fran S",
        "content": "Jannine is very competent and knowledgeable about all areas of skin care. She makes excellent suggestions based upon your own special concerns and the results are outstanding. She keeps her clients up to date on new skin care technology and will do small extras in order to ensure the best possible outcome for her clients' needs. She explains all the various procedures clearly and describes honestly what you can expect so you can make an informed decision. She is indispensable to me and I rely on her expertise, her advice and her skill. She is very pleasant and friendly. I cannot recommend highly enough.",
        "clientSince": "2011" 
    },
    {
        "id": 7,
        "name": "Rose",
        "content": "She truly is my personal skin angel. I have extremely sensitive skin, rosacea, scars, sun damage and she has helped me with all of it, and taught me how to take care of my skin. And she's very funny.",
        "clientSince": "2017" 
    }
];

export default testimonials